import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navbar, Nav, NavDropdown, Container, Row, Col } from "react-bootstrap";
import * as S from "./style";
import { logout } from "../../store/slices/auth";
import { getCampaignErrorCount } from "../../store/slices/campaigns/campaignErrors";
import { getChannels } from "../../store/slices/channels/channels";
// const logo = 'https://dev-creditq-media.s3.ap-south-1.amazonaws.com/cms-media/logo.png'

export const Topnav = () => {
  const { campaignErrorCount } = useSelector((state) => state.campaignErrorsSlice);
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const userName = user?.data?.name ?? "";

  const handleLogout = () => {
    dispatch(logout());
  };

  useEffect(() => {
    dispatch(getCampaignErrorCount());
    dispatch(getChannels());
  }, []);

  return (
    <S.NavWrapper>
      <S.TopNavbar expand="lg">
        <Navbar.Brand href="/app">
          <S.BrandTitle>Campaign Portal</S.BrandTitle>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">

            {/* <S.NotiLink href="/campaigns/errors">
              Notifications
              {campaignErrorCount > 0 && (
                <S.Badge>{campaignErrorCount}</S.Badge>
              )}
            </S.NotiLink> */}

            <NavDropdown title={userName} id="user-nav-dropdown" align="end">
              <NavDropdown.Item onClick={handleLogout}>
                Logout
              </NavDropdown.Item>
            </NavDropdown>

          </Nav>
        </Navbar.Collapse>
      </S.TopNavbar>
    </S.NavWrapper>
  );
};

